import React from 'react';
import { ReactComponent as ArrowIcon } from '@blink/assets/src/icons/arrowRight.svg';
import { ALLOWANCE_STATUS } from '@blink/components/src/types';

import { useAllowanceStepStyle } from './AllowanceStep.style';

import { Loader } from '@/shared/ui';

type AllowanceStepType = {
    title: string;
    amount: string;
    isLoading?: boolean;
    status: ALLOWANCE_STATUS;
    border?: boolean;
};

export const AllowanceStep = ({ amount, title, isLoading, status, border }: AllowanceStepType) => {
    const baseClasses = useAllowanceStepStyle();
    return (
        <div className={`${baseClasses.root} ${border && baseClasses.border}`}>
            {isLoading && status === ALLOWANCE_STATUS.PROCESSING && <Loader className='mr-3' />}
            <section className={baseClasses.main}>
                <span className={baseClasses.title}>{title}</span>
                <span className={baseClasses.mainAmount}>
                    <ArrowIcon />
                    {amount}
                </span>
            </section>
        </div>
    );
};
